import * as React from 'react'

import SvgSprite from 'airship/patterns/svg-sprite'

import errorContext from './error-context'
import ErrorText from './ErrorText'

interface ErrorProps {
  id: string
}

const ErrorDisplay: React.FC<ErrorProps> = ({id}) => {
  const {context} = React.useContext(errorContext)
  const errors = context.errors[id] || []
  // TODO (TPS-88): handle multiple errors
  const error = errors.length ? errors[0] : null

  return error ? (
    <span className="validator__error u-flex u-flex-align-items-center">
      <SvgSprite name="attention-fill" />
      <ErrorText error={error} />
    </span>
  ) : null
}

export default ErrorDisplay
